import { gql } from '../__generated__';

export const ENTITY_PAGE_FOLLOW_MUTATION = gql(`
  mutation xcpEntityPageFollow($followedId: ID!) {
      entityPageFollow(input: { followedId: $followedId }) {
        error {
          message
        }
      }
    }
`);
